<template>
  <div class="ui stacked blue segment">
    <div
      class="ql-editor"
      data-gram="false"
      contenteditable="true"
      v-html="receipt_render"
    ></div>
    <vue-editor v-model="dummy" class="hidden"></vue-editor>
  </div>
</template>

<script>
// import { local_api, error_toast } from "@/utils";
import filters from "@/filters";
import { VueEditor } from "vue2-editor";
import { enterprise_setup } from "@/utils";
// import _ from "lodash";

export default {
  name: "PaymentModalReceipt",
  filters: filters,
  components: {
    VueEditor,
  },
  props: {
    payment_in: Object,
    template_in: String,
    customer_in: Object,
    total_in: Number,
    cart_in: Array,
    session_in: Object,
  },
  data() {
    return { dummy: "" };
  },
  computed: {
    receipt_render() {
      let vm = this;
      let ent_setup = enterprise_setup(vm);
      var template = this.template_in || "";

      var _products = this.cart_in.reduce((prev, curr) => {
        let subtotal = filters.formatCurrency(curr.subtotal);
        return (
          prev +
          `<div class="item"><span>${curr.quantity}</span> x <span>${curr.product.name}</span><span style="float:right">${subtotal}</span></div>`
        );
      }, "");

      var _payment;
      if (this.payment_in.sale && this.payment_in.sale.payment)
        _payment = JSON.parse(this.payment_in.sale.payment).reduce(
          (prev, curr) => {
            let amount = filters.formatCurrency(curr.amount);
            if (curr.amount)
              return (
                prev +
                `<div class="item"><span>${curr.name}</span><span style="float:right">${amount}</span></div>`
              );
            else return prev;
          },
          "",
        );

      let replacements = [
        { target: "[TOTAL]", value: filters.formatCurrency(this.total_in) },
        {
          target: "[SALE_ID]",
          value: this.payment_in.sale ? this.payment_in.sale.uuid : "",
        },
        {
          target: "[DATE]",
          value: filters.formatDate({}, ent_setup.second_detailed_date_format),
        },
        {
          target: "[PRODUCTS]",
          value: `<div class="ui bulleted divided list">${_products}</div>`,
        },
        {
          target: "[PAYMENT]",
          value: `<div class="ui divided list">${_payment}</div>`,
        },
        {
          target: "[BILLING_INFORMATION]",
          value: this.buildBillingInfo(),
        },
      ];

      replacements.map((r) => {
        template = template.replace(r.target, r.value);
      });
      return template;
    },
  },
  methods: {
    buildBillingInfo() {
      if (!this.payment_in.billing_data) return "";
      else {
        return `<div class="ui two column grid" style="margin: 5px 0">
                  <div class="column" style="padding: 0">${this.$t(
                    "customer",
                  )}: ${this.payment_in.billing_data._bill.receiver_name}</div>
                  <div class="column" style="padding: 0">${this.$t("nit")}: ${
          this.payment_in.billing_data._bill.receiver_nit
        }</div>
                  <div class="column" style="padding: 0">${this.$t(
                    "address",
                  )}: ${
          this.payment_in.billing_data._bill.receiver_address
        }</div>
                  <div class="column" style="padding: 0">${this.$t("email")}: ${
          this.payment_in.billing_data._bill.receiver_email
        }</div>                          
                </div>${this.buildFELInfo()}`;
      }
    },
    buildFELInfo() {
      if (!this.payment_in.billing_data.fel_data) return "";
      else {
        return `<h4 class="ui dividing header">${this.$t(
          "electronic billing info",
        )}</h4><div class="ui two column grid" style="margin: 5px 0">
                  <div class="column" style="padding: 0">${this.$t("batch")}: ${
          this.payment_in.billing_data.fel_data.Batch
        }</div>
                  <div class="column" style="padding: 0">${this.$t(
                    "serial",
                  )}: ${
          this.payment_in.billing_data.fel_data.Serial
        }</div>                  
                </div><div class="column" style="padding: 0">${this.$t(
                  "document number",
                )}: ${
          this.payment_in.billing_data.fel_data.DocumentGUID
        }</div>`;
      }
    },
  },
  mounted() {},
  watch: {},
  updated: function () {},
};
</script>

<style></style>
